import { makeStyles } from '@material-ui/styles'

const drawerWidth = 240

export default makeStyles(theme => ({
  root: {
    width: '100%',
  },
  childContainer: {
    padding: 10,
  },
  appbar:{
    [theme.breakpoints.down('sm')]: {
      padding: 10,
    },
  },
  toolbar:{
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    '@media(max-width: 1170px)': {
      padding: 10,
      flexWrap: 'wrap',
    },
    '@media print': {
      display: 'initial',
      margin: 'initial',
      padding: 'initial',
      border: 'initial',
    },
  },
  grow: {
    flexGrow: 1,
  },
  sectionLogo: {
    display: 'flex',
    marginRight: '4rem',
    alignItems: 'center',
    '@media(max-width: 1170px)': {
      marginBottom: 10,
    },
     '@media print': {
       display: 'none',
     },
  },
  consultsButton: {
    marginLeft: 20,
    minHeight: 36,
    padding: '0 12px',
    textTransform: 'none',
    fontSize: '1.4rem',
    fontWeight: 500,
    borderRadius: 4,
    color: theme.palette.primary.lighter,
    opacity: 0.92,
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.12)',
      opacity: 1,
    },
    '& .MuiButton-label': {
      letterSpacing: '0.01em',
    },
    '@media(max-width: 1170px)': {
      marginLeft: 10,
    },
    '@media print': {
      display: 'none',
    },
  },
  logoContainer:{
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  logoImg: {
    height: 45,
    marginLeft: 20,
    marginRight: 20,
  },
  menubar:{
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    '@media(max-width: 1170px)': {
      flexWrap: 'wrap',
      width: '100%',
    },
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
  sectionUser: {
    display: 'flex',
    minHeight: 'inherit',
    '@media(max-width: 1170px)': {
      display: 'none',
      marginTop: 30,
      paddingTop: 15,
      borderTop: `1px solid ${theme.palette.primary.grayLight}`,
    },
    '@media print': {
      display: 'initial',
      margin: 'initial',
      padding: 'initial',
      border: 'initial',
    },
  },
  listNav: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '@media(max-width: 1170px)': {
      flexDirection: 'column',
      alignItems: 'flex-start',
      width: 240,

    },
  },
  listNavItem: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingLeft: 20,
    paddingRight: 20,
    transition: 'all 0.2s',
    '&:hover': {
      backgroundColor: theme.palette.primary.hover,
      cursor: 'pointer',
    },

    '@media(max-width: 1170px)': {
      padding: 10,
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      width: '100%',
      '&:hover': {
        backgroundColor: theme.palette.primary.grayLight,
      },
    },
    '@media print': {
      display: 'none',
    },
  },
  listNavItemUsername: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingLeft: 20,
    paddingRight: 20,
    '@media(max-width: 1170px)': {
      padding: 10,
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      width: '100%',
      '&:hover': {
        backgroundColor: theme.palette.primary.grayLight,
      },
    },
    '@media print': {
      display: 'flex',
      width: '100vw',
    },
  },
  listNavItemSep: {
    marginLeft: 10,
  },
  menuItem: {
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
    color: theme.palette.primary.lighter,
    marginRight: 10,
    marginLeft: 5,
    '@media(max-width: 1170px)': {
      color: '#333',
    },
  },
  dateTime: {
    display: 'none',
    '@media print': {
      display: 'initial',
    },
  },
  logolf: {
    display: 'none',
    '@media(max-width: 1170px)': {
      color: '#333',
      display: 'flex',
      alignItems: 'center',
      textDecoration: 'none',
      marginRight: 10,
      marginLeft: 5,
    },
  },
  menuIcon: {
    marginLeft: 10,
  },
  dropdown: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.lighter,
  },
  search: {
    position: 'relative',
    borderRadius: 13,
    backgroundColor: theme.palette.common.white,
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    color: theme.palette.primary.gray,
    '@media(max-width: 1170px)': {
      marginBottom: 10,
      marginRight: 'auto',
    },
  },
  searchIcon: {
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    right: 10,
    top: 7,
    color: theme.palette.primary.main,
  },
  inputRoot: {
    color: theme.palette.primary.gray,
    width: 250,
  },
  inputInput: {
    paddingTop: theme.spacing(),
    paddingRight: theme.spacing(),
    paddingBottom: theme.spacing(),
    paddingLeft: theme.spacing(),
    transition: theme.transitions.create('width'),
    width: '100%',
  },
  sectionDesktop: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  version: {
    bottom: 2,
    color: theme.palette.primary.hover,
    position: 'absolute',
  },
}))
